import gql from 'graphql-tag';
import { containerFollowUp } from './fragments';

export const FILTERED_CONTAINERS_FOLLOW_UP = gql` 
${containerFollowUp}  
query filteredContainersFollowUpForFulfillment(
  $input: FilteredContainerFollowUpInput
) {
  filteredContainersFollowUp(
    input: $input
  ) {
    ...containerFollowUp
  }
}
`;
